var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"calendar-select",class:{thinner: _vm.thinner},on:{"change":_vm.changeMonth}},_vm._l((_vm.month_names),function(month_name,key){return _c('option',{domProps:{"selected":_vm.selected_month === key,"value":key}},[_vm._v("\n    "+_vm._s(_vm.$t(`vacations.${month_name}`))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }